$(document).ready(function(e){
  if($('.main_banner').length>0){
    var dataautoplay = $('.main_banner').data('autoplay');
    var dataduration = $('.main_banner').data('duration');
    $('.main_banner').slick({
      dots: true,
      infinite: true,
      autoplaySpeed: dataduration,
      autoplay:dataautoplay,
      arrows:false,
      slidesToShow: 1
    });
  }
  var hedader_height = $('.head_main').height();
  $('body').css('padding-top',hedader_height);
  $('.mobile_drawer,.currency_drawer').css('top',hedader_height);
  $('.template-index main > div:first-child > div:first-child').css('margin-top',-Math.abs(hedader_height));
  if($(window).width()<992){
  	$('.gwt_drawers').css('top',hedader_height);
  }
  $(document).on('click', '.variant_cls input[type="radio"]', function() {
    var current_radio__val = $(this).val();
    $(this).closest('.variant_cls').find('.variant_name').text(' : '+current_radio__val);
    $(this).closest('.variant_cls').find('.select_variant').hide();
  });
  $('.prebtncart').on('click',function(e){
    e.preventDefault();
    $('.variant_cls').each(function(e){
      var selected_len = $(this).find('[type=radio]:checked').length;
      if(selected_len>0){
        $(this).find('.select_variant').hide();
      }else{
        $(this).find('.select_variant').show();
      }
    });
  });
  $('.pdp_acco_title').on('click',function(e){
  	e.preventDefault();
    $(this).closest('.pdp_acc_wrap').toggleClass('active').siblings().removeClass('active');
    $(this).next('.pdp_acc_content').slideToggle().closest('.pdp_acc_wrap').siblings().find('.pdp_acc_content').slideUp();
  });
  $('.imgzoomcls').on('click',function(e){
  	e.preventDefault();
    $('.product__media-item').addClass('hidelistimg');
    $(this).closest('.product__media-item').removeClass('hidelistimg');
    $(this).closest('.product__media-item').addClass('active').siblings().removeClass('active');
    $(window).scrollTop(0);
    var data_index = $(this).data('index');
    $('.pdp_slider').slick('slickGoTo', data_index); 
    $('.pdp_slider').addClass('activeslide');
    $('.product__media-list').removeClass('activeslide');
  });
  $('.close_zooom').on('click',function(e){
  	e.preventDefault();
    $('.product__media-item').removeClass('hidelistimg active');    
    $('.pdp_slider').removeClass('activeslide');
    $('.product__media-list').addClass('activeslide');
  });
  $('.blog_Scrolldown').on('click',function(e){
  	e.preventDefault();
    //$(document).scrollTop($(document).height());
    $('html, body').animate({scrollTop:$(document).height()}, 1000);       
  });
  $(window).scroll(function(){
    if ($(window).scrollTop() >= 100) {
      $('.head_main').addClass('white_header');
    }else{
      $('.head_main').removeClass('white_header');
    }
  });
  $('.faq_que a').on('click',function(e){
  	e.preventDefault();    
    $(this).closest('.faq_box').siblings().find('.faq_ans').slideUp();
    $(this).closest('.faq_box').siblings().removeClass('active');
    $(this).parent().next('.faq_ans').slideToggle();
    $(this).closest('.faq_box').toggleClass('active');
  });
  $('.faq_catlist a').click(function(e) {
    e.preventDefault();
    $(this).parent().addClass('active').siblings().removeClass('active');
    var target = $(this).attr('href');
    console.log(target);
    $('html, body').animate({
      scrollTop: ($(target).offset().top - hedader_height)
    },1200);
  });
  $('.drawer_account').on('click',function(e){
  	e.preventDefault();
    $('.register_box').show();
    $('.login_box,.recover_box').hide();
  });
  $('.drawerrecover').on('click',function(e){
  	e.preventDefault();
    $('.recover_box').show();
    $('.register_box,.login_box').hide();
  });
  $('.drawer_cancel').on('click',function(e){
  	e.preventDefault();
    $('.login_box').show();
    $('.recover_box,.register_box').hide();
  });
  $('.drawer_login').on('click',function(e){
  	e.preventDefault();
    $('.login_box').show();
    $('.register_box').hide();
  });
  $('.header_account').on('click',function(e){
  	e.preventDefault(e);
    $('body').toggleClass('accountopen');
    $('body').removeClass('CartOpen open-filter open_search menu-open currency_open');
  });
  $(document).on('click','.gwt_close,.obverlaybg',function(e){
    e.preventDefault();
  	$('body').removeClass('accountopen CartOpen open-filter open_search menu-open currency_open');
  });
  if($('.NewsletterPopup').length>0){
    $(window).on('load',function() {
      var popuptime = $('.NewsletterPopup').data('delay');
      var delaytime = popuptime*1000;
      if(typeof(Storage) !== "undefined") {
        if(sessionStorage.newsletter_popup == 'true'){
        }
        else{
          sessionStorage.newsletter_popup = 'true';
          setTimeout(function () {
            if( $.cookie("newsletter") == 'hide_newsletter' ){
              $(".NewsletterPopup").addClass('open_newsletter');
            }
            else{
              $(".NewsletterPopup").addClass('open_newsletter');
              $.cookie("newsletter", "hide_newsletter", { expires: 1 });
            }
          }, delaytime);
        }
      }
    });
    $('.news_close').on('click',function(e){
    	$(".NewsletterPopup").removeClass('open_newsletter');
    });
  }
  $('.header_search,.d_close_search').on('click',function(e){
  	e.preventDefault();
    $('body').toggleClass('open_search');
    $('body').removeClass('accountopen CartOpen open-filter menu-open currency_open');
    $(".search_input_top").focus();
  });
  $('.first_level_tab').on('click',function(e){
  	e.preventDefault();
    $('.mob_menu_top li').removeClass('active');
    $(this).closest('li').addClass('active');
    var menuhandle = $(this).closest('li').data('title');
    $('.m_f_tab').removeClass('active');
    $('.m_f_tab[data-title="'+menuhandle+'"]').addClass('active');
  });
  $('.mob_navbtn').on('click',function(e){
  	e.preventDefault();
    $('body').toggleClass('menu-open');
    $('body').removeClass('accountopen CartOpen open-filter open_search');
  });
  $('.ftr_arw').on('click',function(e){
  	e.preventDefault();
    $(this).closest('.footerblock').find('.ftr_title').toggleClass('active');
    $(this).closest('.footerblock').find('.ftr_content').slideToggle();
  });
  $('body').keydown(function(e){
    if(e.keyCode == 27) {
      $('body').removeClass('accountopen CartOpen open-filter open_search menu-open ');
    }
  });
  $('.mob_cur_btn,.currency_close').on('click',function(e){
  	$('body').toggleClass('currency_open');
  });
  $('.currency_listlink').on('click',function(e){
    var data_val = $(this).data('value');
    $('.currencies option').each(function(e){
      var eachval = $(this).val();
      if(data_val==eachval){
        $(this).prop('selected',true);
        $("#huratips_currency_switcher_form input[name=return_to]").val(window.location.pathname);
        $("#huratips_currency_switcher_form").addClass('huratips_currency_switcher_form');
        $(".huratips_currency_switcher_form").submit();
      }
    });
  });
  $('.cu_lng').on('click',function(e){
  	$('.lan_cur_box').slideToggle();
    return false;
  });
  var active_currency = $('.curr_linkcls.active a').attr('data-value');  
  $('.active_cur').text(active_currency);
  $('.lan_cur_box  li a').on('click',function(e){
    //$('.lan_cur_box').slideUp();
  });
  $(document).on("click", function(event) {
    var $trigger = $(".lan_cur_box,.lan_cur_box .dlflex*");
    if($trigger !== event.target && !$trigger.has(event.target).length){
      $('.lan_cur_box').slideUp();
    }        
  });
  $(".transparent_header .meganavlist,.transparent_header .nav_droplist").mouseenter(function() {
    $('.head_main').removeClass('transparent_header');
  }).mouseleave(function() {
    $('.head_main').addClass('transparent_header');
  });
  $(window).scroll(function(){
  	var colltop_height = $('.head_main').height() + $('.collection_hedaer').height();
    if ($(window).scrollTop() >= colltop_height) {
      $('.collection_hedaer').addClass('stikcy_coll_header');
    }else{
      $('.collection_hedaer').removeClass('stikcy_coll_header');
    }
  });
  if($('.pdp_slider').length>0){
    $('.pdp_slider').slick({
      dots: false,
      infinite: true,
      arrows:true,
      slidesToShow: 1
    });    
  }
});


// display currency instead of currency country in header

$(document).ready(function(){
if ($('.active_cur').html() === 'NL') {
    $('.active_cur').html('EUR')
} else if ($('.active_cur').html() === 'GB') {  
    $('.active_cur').html('GBP')
} else if ($('.active_cur').html() === 'US') {
    $('.active_cur').html('USD')
}
});
